import { Card, CardContent, TextField } from "@material-ui/core";
// import { makeStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Timeline from "@material-ui/lab/Timeline";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import AppHeader from "@saleor/components/AppHeader";
import CardTitle from "@saleor/components/CardTitle";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import { commonMessages, sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { SearchProductVariants_search_edges_node } from "@saleor/searches/types/SearchProductVariants";
import {
  ShipmentDetails_shipment,
  ShipmentDetails_shipment_orders
} from "@saleor/shipment/types/ShipmentDetails";
import { FetchMoreProps, ListActions, PageListProps } from "@saleor/types";
import moment from "moment-timezone";
import React from "react";
import { useIntl } from "react-intl";

// const useStyles = makeStyles({
//   table: {
//     minWidth: 650,
//   },
// });

function createData(number, status, lines) {
  return { number, status, lines };
}

// import InstagramProducts from "../InstagramProducts";
// import InstagramTagListPage from "../InstagramTagListPage";

export interface ShipmentDetailsPageProps extends PageListProps, ListActions {
  shipment: ShipmentDetails_shipment;
  disabled: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  addInsTag: () => void;
  deleteInsTag: (id: string) => void;
  onSubmit: (data: ShipmentDetailsPageFormData) => void;
  onBack: () => void;
  onProductUnassign: (id: string, event: React.MouseEvent<any>) => void;
  fetchMoreVariants: FetchMoreProps;
  fetchVariants: (data: string) => void;
  toolbarTag: React.ReactNode;
  variants: SearchProductVariants_search_edges_node[];
  // onRowTagClick: (id: string) => () => void;
}

export interface ShipmentDetailsPageFormData {
  // image: string;
  // published: boolean;
  // published: boolean;
  // image: string;
  shipmentCompany: string;
  orderNumber: string | null;
  trackingNumber: string | null;
  trackingCode: string;
  totalWeight: string;
  shipedDate: any;
  shipedDelivered: any | null;
  shippingDetails: any;
  shipmentInfo: any;
  courierCode: string;
  sku: string | null;
  orders: Array<ShipmentDetails_shipment_orders | null> | null;
}

const ShipmentDetailsPage: React.FC<ShipmentDetailsPageProps> = ({
  shipment,
  onSubmit,
  // disabled,
  // saveButtonBarState,
  // variants: variantChoiceList,
  onBack
  // addInsTag,
  // toolbarTag,
  // fetchMoreVariants,
  // fetchVariants,
  // deleteInsTag,
  // onRowTagClick,
  // ...ShipmentDetailsPageProps
}) => {
  const intl = useIntl();
  // const classes = useStyles();
  const initialForm: ShipmentDetailsPageFormData =
    shipment === null
      ? {
          courierCode: "",
          shipmentCompany: "",
          orderNumber: "",
          trackingNumber: "",
          trackingCode: "",
          totalWeight: "",
          shipedDate: "",
          shipedDelivered: "",
          shippingDetails: "",
          shipmentInfo: "",

          orders: [],
          sku: ""
        }
      : {
          courierCode: maybe(() => shipment.courierCode, ""),
          shipmentCompany: maybe(() => shipment.shipmentCompany, ""),
          orderNumber: maybe(() => shipment.orderNumber, ""),
          trackingNumber: maybe(() => shipment.trackingNumber, ""),
          trackingCode: maybe(() => shipment.trackingCode, ""),
          totalWeight: maybe(() => shipment.totalWeight, ""),
          shipedDate: maybe(() => shipment.shipedDate, ""),
          shipedDelivered: maybe(() => shipment.shipedDelivered, ""),
          shippingDetails: maybe(() => shipment.shippingDetails, ""),
          shipmentInfo: maybe(() => shipment.shipmentInfo, ""),
          sku: maybe(() => shipment.sku, ""),
          orders: maybe(() => shipment.orders, [])
        };
  const handleSubmit = (data: ShipmentDetailsPageFormData) =>
    onSubmit({
      ...data
    });

  const rows = initialForm.orders;
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<DialogProps["scroll"]>("paper");

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setOpen(true);
    setScroll(scrollType);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef<HTMLElement>(null);

  function Row(props: { row: ReturnType<typeof createData> }) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    // const classes = useRowStyles();

    return (
      <React.Fragment>
        <TableRow>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.number || ""}
          </TableCell>
          <TableCell>{row.status || ""}</TableCell>
          {/* <TableCell>{row.number || ''}</TableCell>
            <TableCell>{row.userEmail || ''}</TableCell>
            <TableCell>{row.number || ''}</TableCell> */}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  lines
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>productName</TableCell>
                      <TableCell>productSku</TableCell>
                      <TableCell>variantName</TableCell>
                      <TableCell>quantity</TableCell>
                      {/* <TableCell>lines5</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.lines.map(row => (
                      <TableRow>
                        <TableCell>{row.productName || ""}</TableCell>
                        <TableCell>{row.productSku || ""}</TableCell>
                        <TableCell>{row.variantName || ""}</TableCell>
                        <TableCell>{row.quantity || ""}</TableCell>
                        {/* <TableCell>{row.productName || ''}</TableCell> */}
                      </TableRow>
                    ))}
                    {/* {row.history.map((historyRow) => (
                        <TableRow key={historyRow.date}>
                          <TableCell component="th" scope="row">
                            {historyRow.date}
                          </TableCell>
                          <TableCell>{historyRow.customerId}</TableCell>
                          <TableCell align="right">{historyRow.amount}</TableCell>
                          <TableCell align="right">
                            {Math.round(historyRow.amount * row.price * 100) / 100}
                          </TableCell>
                        </TableRow>
                      ))} */}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  if (rows[0]) {
    return (
      <Form initial={initialForm} onSubmit={handleSubmit}>
        {({ change, data }) => (
          <Container>
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.shipment)}
            </AppHeader>
            <PageHeader
              title={intl.formatMessage({
                defaultMessage: "Shipment Details",
                description: "Shipment Details"
              })}
            />
            <Grid>
              <Card>
                <CardTitle
                  title={intl.formatMessage(commonMessages.generalInformations)}
                ></CardTitle>
                <CardContent>
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "shipmentCompany",
                      description: "shipmentCompany"
                    })}
                    name={
                      "shipmentCompany" as keyof ShipmentDetailsPageFormData
                    }
                    fullWidth
                    value={data.shipmentCompany}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "orderNumber",
                      description: "orderNumber"
                    })}
                    name={"orderNumber" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.orderNumber}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "trackingNumber",
                      description: "trackingNumber"
                    })}
                    name={"trackingNumber" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.trackingNumber}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: " trackingCode",
                      description: " trackingCode"
                    })}
                    name={" trackingCode" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.trackingCode}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "totalWeight",
                      description: "totalWeight"
                    })}
                    name={"totalWeight" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.totalWeight}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "shipedDate",
                      description: "shipedDate"
                    })}
                    name={"shipedDate" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={moment(data.shipedDate).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "shipedDelivered",
                      description: "shipedDelivered"
                    })}
                    name={
                      "shipedDelivered" as keyof ShipmentDetailsPageFormData
                    }
                    fullWidth
                    value={moment(data.shipedDelivered).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "courierCode",
                      description: "courierCode"
                    })}
                    name={"courierCode" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.courierCode}
                    onChange={change}
                  />
                  <FormSpacer />
                </CardContent>
              </Card>
              <FormSpacer />

              <Card>
                <CardTitle title="Product shipped"></CardTitle>
                <TableContainer component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>order_id</TableCell>
                        <TableCell>status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, index) => (
                        <Row key={index} row={row} />
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>

            {/* 物流弹框 */}
            <Dialog
              fullWidth={true}
              maxWidth={"lg"}
              open={open}
              onClose={handleClose}
              scroll={scroll}
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
            >
              <DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle>
              <DialogContent dividers={scroll === "paper"}>
                <DialogContentText
                  id="scroll-dialog-description"
                  ref={descriptionElementRef}
                  tabIndex={-1}
                >
                  {/* 时间线 */}
                  <Timeline>
                    {/* {JSON.parse(initialForm?.shippingDetails)?.trackinfo?.map( */}
                    {initialForm.shipmentInfo === "{}"
                      ? ""
                      : JSON.parse(initialForm?.shipmentInfo)?.map(row => (
                          <TimelineItem>
                            <TimelineOppositeContent>
                              <Typography color="textSecondary">
                                {row.date}
                              </Typography>
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                              <TimelineDot />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                              <Typography>[ {row.details} ]</Typography>
                              <Typography>{row.statusdescription}</Typography>
                            </TimelineContent>
                          </TimelineItem>
                        ))}
                  </Timeline>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleClose} color="primary">
                  Subscribe
                </Button>
              </DialogActions>
            </Dialog>

            <br />
            <Button
              onClick={handleClickOpen("paper")}
              variant="contained"
              color="primary"
            >
              Shipment Tracking
            </Button>
            {/* <Button style={{margin:'0 0 0 50px'}} variant="contained" color="primary">暂时没用 能力有限</Button> */}
          </Container>
        )}
      </Form>
    );
  } else {
    return (
      <Form initial={initialForm} onSubmit={handleSubmit}>
        {({ change, data }) => (
          <Container>
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.shipment)}
            </AppHeader>
            <PageHeader
              title={intl.formatMessage({
                defaultMessage: "Shipment Details",
                description: "Shipment Details"
              })}
            />
            <Grid>
              <Card>
                <CardTitle
                  title={intl.formatMessage(commonMessages.generalInformations)}
                ></CardTitle>
                <CardContent>
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "shipmentCompany",
                      description: "shipmentCompany"
                    })}
                    name={
                      "shipmentCompany" as keyof ShipmentDetailsPageFormData
                    }
                    fullWidth
                    value={data.shipmentCompany}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "orderNumber",
                      description: "orderNumber"
                    })}
                    name={"orderNumber" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.orderNumber}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "trackingNumber",
                      description: "trackingNumber"
                    })}
                    name={"trackingNumber" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.trackingNumber}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: " trackingCode",
                      description: " trackingCode"
                    })}
                    name={" trackingCode" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.trackingCode}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "totalWeight",
                      description: "totalWeight"
                    })}
                    name={"totalWeight" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.totalWeight}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "shipedDate",
                      description: "shipedDate"
                    })}
                    name={"shipedDate" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={moment(data.shipedDate).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "shipedDelivered",
                      description: "shipedDelivered"
                    })}
                    name={
                      "shipedDelivered" as keyof ShipmentDetailsPageFormData
                    }
                    fullWidth
                    value={moment(data.shipedDelivered).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                    onChange={change}
                  />
                  <FormSpacer />
                  <TextField
                    disabled
                    label={intl.formatMessage({
                      defaultMessage: "courierCode",
                      description: "courierCode"
                    })}
                    name={"courierCode" as keyof ShipmentDetailsPageFormData}
                    fullWidth
                    value={data.courierCode}
                    onChange={change}
                  />
                  <FormSpacer />
                </CardContent>
              </Card>
              <FormSpacer />
            </Grid>

            {/* <Button variant="contained" color="primary">Primary</Button>
              <Button style={{margin:'0 0 0 50px'}} variant="contained" color="primary">Primary</Button> */}
          </Container>
        )}
      </Form>
    );
  }
};

export default ShipmentDetailsPage;
